import { RequestDay } from '../../models/request-day'

/**
 * Sums the calculation codes across checked days.
 *
 * Prefers the `calculationCode` stored in request state (set by the user via
 * the dropdown). Falls back to `getCode(day)` for days without a state code
 * — this preserves backward compatibility for callers that haven't seeded
 * state codes yet.
 */
export const calculateTotalRequestedShifts = (
  selectedDays: RequestDay[] | null | undefined,
  getCode: ((day: Date) => string | null) | undefined
): number => {
  if (!selectedDays || !getCode) return 0
  return selectedDays
    .filter(day => day.checked)
    .reduce((sum, day) => {
      const code = day.calculationCode ?? getCode(day.day!) ?? ''
      return sum + (Number(code) || 0)
    }, 0)
}
